export default {
  SuDecrementList: {
    TitleList: 'Ghi giảm CCDC',
  },
  SuDecrementDetail: {
    Title: 'Phiếu ghi giảm CCDC',
    Text: {
      OtherInfo: 'Thông tin khác',
      GeneralInfo: 'Thông tin chung',
      Save: 'Cất (Ctrl + S)',
      Department: 'Phòng ban',
      DepartmentName: 'Tên phòng ban',
      RefDate: 'Ngày CT',
      RefNo: 'Số CT',
      PostedDate: 'Ngày HT',
      Description: 'Diễn giải',
      CTReference: 'CT tham chiếu',
    },
    TextTooltip: {
      RefDate: 'Ngày chứng từ',
      RefNo: 'Số chứng từ',
      PostedDate: 'Ngày hạch toán',
    },
    PopupCheckInventory: {
      Message: 'Thiếu thông tin CCDC. Xin vui lòng kiểm tra lại.',
      Title: 'Cất không thành công',
      Button: 'Đồng ý',
    },
    PopupCheckAmount: {
      Message: 'Thông tin chứng từ thiếu Số tiền.',
      Title: 'Cất không thành công',
      Button: 'Đồng ý',
    },
    PopupCheckDepartment: {
      MessageFirst: 'Chưa ghi tăng CCDC ',
      MessageSecond: ' cho phòng ban ',
      MessageLast: '. Bạn không thể ghi giảm công cụ này.',
      Title: 'Cất không thành công',
      Button: 'Đồng ý',
    },
    PopupCheckNullDepartment: {
      Message: 'Chưa nhập phòng ban',
      Title: 'Cất không thành công',
      Button: 'Đồng ý',
    },
    PopupCheckAmount: {
      Content: 'Số ký tự cột thành tiền vượt quá số lượng quy định (14 ký tự). Vui lòng kiểm tra lại.',
      Title: 'Không hợp lệ',
    },
  },
};
